if (!customElements.get('cart-discount')) {
  class CartDiscount extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.input = this.querySelector('[name="discount"]');
      this.submitButton = this.querySelector('[type="submit"]');
      this.removeButton = this.querySelector('.js-remove-discount');
      this.message = this.querySelector('.cart-discount__message');
      this.cartDrawer = this.closest('cart-drawer');

      this.form?.addEventListener('submit', this.handleSubmit.bind(this));
      this.removeButton?.addEventListener('click', this.handleRemove.bind(this));
    }

    handleSubmit(evt) {
      evt.preventDefault();

      const discountCode = this.input.value.trim();
      if (!discountCode) {
        this.showMessage(this.dataset.blankMessage, true);
        return;
      }

      this.updateDiscount(discountCode);
    }

    handleRemove() {
      this.updateDiscount('', true);
    }

    async updateDiscount(discountCode, isRemoval = false) {
      const giftPicker = window.HBGiftPicker?.instance;
      if (giftPicker?.busy) return;
      let requestedDiscount = discountCode;
      if (giftPicker?.state.active && giftPicker.config.discountCode
        && giftPicker.state.items.some((item) => item.giftCampaign === giftPicker.config.campaign)) {
        requestedDiscount = window.HBGiftPicker.mergeCodes(
          [{ code: discountCode }], giftPicker.config.discountCode
        );
      }
      this.setLoading(true);
      this.hideMessage();

      try {
        const sections = this.getSectionsToRender();
        const response = await fetch(theme.routes.cartUpdate, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            discount: requestedDiscount,
            sections,
            sections_url: window.location.pathname
          })
        });
        const data = await response.json();

        if (!response.ok) throw new Error(data.description || response.status);

        const isApplied = isRemoval || CartDiscount.cartContainsDiscount(data, discountCode);
        const message = isRemoval ? this.dataset.removeMessage : this.dataset.appliedMessage;

        this.renderUpdatedCart(data, isApplied ? message : this.dataset.errorMessage, !isApplied);
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.showMessage(theme.strings.cartError, true);
      } finally {
        this.setLoading(false);
      }
    }

    getSectionsToRender() {
      if (!this.cartDrawer) return [];

      return [
        this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', ''),
        'cart-icon-bubble'
      ];
    }

    renderUpdatedCart(data, message, isError) {
      if (this.cartDrawer && data.sections) {
        this.cartDrawer.renderContents(data, false);
        document.dispatchEvent(new CustomEvent('on:css-var-height:update'));

        const refreshedDiscount = this.cartDrawer.querySelector('cart-discount');
        if (refreshedDiscount) refreshedDiscount.showMessage(message, isError);
      } else {
        this.showMessage(message, isError);
      }
    }

    setLoading(isLoading) {
      this.classList.toggle('is-loading', isLoading);
      if (this.submitButton) this.submitButton.disabled = isLoading;
      if (this.removeButton) this.removeButton.disabled = isLoading;
    }

    showMessage(message, isError = false) {
      if (!this.message) return;

      this.message.textContent = message;
      this.message.classList.toggle('text-error-text', isError);
      this.message.hidden = false;
    }

    hideMessage() {
      if (!this.message) return;

      this.message.textContent = '';
      this.message.hidden = true;
    }

    static cartContainsDiscount(cart, discountCode) {
      const requestedCodes = discountCode
        .split(',')
        .map((code) => code.trim().toLowerCase())
        .filter(Boolean);

      const appliedTitles = [
        ...(cart.cart_level_discount_applications || []).map((discount) => discount.title),
        ...(cart.items || []).flatMap((item) => (item.discounts || []).map((discount) => discount.title))
      ].map((title) => String(title).trim().toLowerCase());

      return requestedCodes.length > 0 && requestedCodes.every((code) => appliedTitles.includes(code));
    }
  }

  customElements.define('cart-discount', CartDiscount);
}
